export const getUsedColors = (version = []) => {
  if (!version && version.length === 0) return [];
  const extractedColors = version.reduce((prev, node) => {
    return [...prev, ...extractUsedColors(node)];
  }, []);
  return [...new Set(extractedColors)];
};

export const extractUsedColors = (node, colors = []) => {
  if (!node) return colors;

  let newColors = colors;
  const { color, backgroundColor, bgColor, children } = node;
  if (color) {
    let hex = color;
    if (color.includes('rgba')) {
      hex = rgbaToHex(color);
    }
    else if (color.includes('rgb')) {
      hex = rgbToHex(color);
    }
    newColors = hex ? [...newColors, hex.toLowerCase()] : newColors;
  }
  if (backgroundColor) {
    let hex = backgroundColor;
    if (backgroundColor.includes('rgba')) {
      hex = rgbaToHex(backgroundColor);
    }
    else if (backgroundColor.includes('rgb')) {
      hex = rgbToHex(backgroundColor);
    }
    newColors = hex ? [...newColors, hex.toLowerCase()] : newColors;
  }
  if (bgColor) {
    let hex = bgColor;
    if (bgColor.includes('rgba')) {
      hex = rgbaToHex(bgColor);
    }
    else if (bgColor.includes('rgb')) {
      hex = rgbToHex(bgColor);
    }
    newColors = hex ? [...newColors, hex.toLowerCase()] : newColors;
  }
  if (children) {
    children.forEach(child => {
      newColors = extractUsedColors(child, newColors);
    });
  }

  return newColors;
};

function rgbaToHex(rgbaString) {
  // Check if the input is in the correct format
  const rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*([01]?\.?\d*|100\.?0*)\)$/;

  const match = rgbaString.match(rgbaRegex);

  if (!match) {
    // Return null for invalid input
    return null;
  }

  // Extract RGBA values from the regex match
  const [, red, green, blue, alpha] = match.map(Number);

  // Convert RGBA to hex
  const redHex = red.toString(16).padStart(2, '0');
  const greenHex = green.toString(16).padStart(2, '0');
  const blueHex = blue.toString(16).padStart(2, '0');
  const alphaHex = Math.round(alpha * 255).toString(16).padStart(2, '0');

  return `#${redHex}${greenHex}${blueHex}${alphaHex}`;
}

const rgbToHex = (rgb) => {
  // Check if the input is in the correct format
  const rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;

  const match = rgb.match(rgbRegex);

  if (!match) {
    // Return null for invalid input
    return null;
  }

  // Extract RGB values from the regex match
  const [, red, green, blue] = match.map(Number);

  // Convert RGB to hex
  // eslint-disable-next-line no-bitwise
  const hex = ((red << 16) | (green << 8) | blue).toString(16).padStart(6, '0');

  return `#${hex}`;
};
